<nz-modal
  [nzWidth]="432"
  [nzStyle]="{ marginTop: '250px' }"
  [nzVisible]="visible"
  [nzClosable]="false"
  [nzContent]="confirmContent"
  [nzFooter]="null"
  class="selfConfirm"
></nz-modal>
<ng-template #confirmContent>
  <div class="confirmBody">
    <div class="confirm-title flexRow">
      <i nz-icon [nzIconfont]="statusIcon[status]" class="confirm-icon {{ status }}"></i>
      <div class="confirm-title-text">{{ title }}</div>
    </div>
    <div class="confirm-content">
      <ng-container *ngIf="content != ''">{{ content }}</ng-container>
      <ng-container *ngIf="content == ''" [ngTemplateOutlet]="body"></ng-container>
    </div>
    <div class="confirm-footer flexRow">
      <div class="flexFull"></div>
      <button nz-button nzType="default" class="confirm-cancel" (click)="clickCancel()" *ngIf="showCancel">{{ cancelText }}</button>
      <button nz-button nzType="primary" class="confirm-sure" (click)="clickSure()" style="margin-left: 8px !important" *ngIf="showSure">
        {{ sureText }}
      </button>
    </div>
  </div>
</ng-template>
